import { render, staticRenderFns } from "./BookingsVoucher.vue?vue&type=template&id=7235f8e4&"
import script from "./BookingsVoucher.vue?vue&type=script&lang=js&"
export * from "./BookingsVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports